import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { LogDetail } from '../../../../../../../types/log.interface';
import { AuscultationDetailComponent } from './auscultation-detail.component';
import { CampaignDetailComponent } from './campaign-detail.component';
import { GenericDetailComponent } from './generic-detail.component';
import { MeasureDetailComponent } from './measure-detail.component';

@Component({
  selector: 'ces-log-detail-item',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MeasureDetailComponent, AuscultationDetailComponent, CampaignDetailComponent, GenericDetailComponent],
  templateUrl: './log-detail-item.component.html',
})
export class LogDetailItemComponent {
  readonly details = input.required<LogDetail[]>();
  readonly first = computed(() => this.details()[0]);

  isSpecialEntity(entity: string): boolean {
    return ['campaign-measure', 'campaign-info', 'campaign'].includes(entity);
  }
}
